/* eslint-disable quote-props */
import { GeneralLedgerTransaction } from 'src/app/domain/financial-statement/models/common/GeneralLedgerTransaction';
import { formats, getCell } from '../../../utils';
import { Rows } from '../../../interfaces';

export const getPreparedData = (data: GeneralLedgerTransaction[], headers: string[]): Rows => {
  const rows: Rows = [];
  rows.push(headers);

  const mappedToHeaders = data.map((d) => getGlTransactionMapping(d));

  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(mapped[header]);
    }
    rows.push(row);
  }
  return rows;
};

export const getPreparedDataByPeriod = (data: Map<string,GeneralLedgerTransaction[]>, headers: string[]): Rows => {
  const rows: Rows = [];
  headers.unshift('Quarter');
  rows.push(headers);

  data.forEach((value, key) => {
    rows.push([key]);
    const mappedToHeaders = value.map((d) => getGlTransactionMapping(d, key));

    for (const mapped of mappedToHeaders) {
      const row = [];
      for (const header of headers) {
        row.push(mapped[header]);
      }
      rows.push(row);
    }
  });
  return rows;
};

const getGlTransactionMapping = (data: GeneralLedgerTransaction, quarter?: string) => {
  // Define the base mapping object
  const glMapping = {
    'Date': String(data.transactionDate),
    'Account number': data.account?.code,
    'Account name': data.account?.name,
    'Debit': getCell({ v: data.debit, z: formats.thousandsSeparator, t: 'n' }),
    'Credit': getCell({ v: data.credit, z: formats.thousandsSeparator, t: 'n' }),
    'Contra account number': data.contraAccount?.code,
    'Contra account name': data.contraAccount?.name,
    'Description': data.description,
    'Journal entry': data.journalEntryCode,
    'Comment': data.comment,
    'isManual': data.isManualEntry,
  };

  if (quarter) {
    return { 'Quarter': quarter, ...glMapping };
  }

  return glMapping;
};
